import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { EmpresaCscResponse } from '../../responses/dfe/empresa_csc.response';
import { EmpresaCscRequest } from '../../requests/dfe/empresa_csc.request';

@Injectable({
  providedIn: 'root',
})
export class EmpresaCscService extends CommonService {
  constructor(
    private httpClient: HttpClient
  ) {
    super();
  }

  private readonly apiUrl = `${environment.urlApiDFe}EmpresaCsc`;

  /**
   * Busca os dados do certificado digital atual da empresa.
   */
  public getEmpresaCsc(): Observable<EmpresaCscResponse> {
    return this.httpClient
      .get<EmpresaCscResponse>(this.apiUrl, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /**
   * Realiza o upload e salvamento de um novo certificado, substituindo o atual se existir.
   * @param request - Objeto com o arquivo do certificado em base64 e a senha.
   */
  public postEmpresaCsc(request: EmpresaCscRequest): Observable<EmpresaCscResponse> {
    // Para requisições com FormData, não definimos o Content-Type, o browser faz isso.

    return this.httpClient
      .post<EmpresaCscResponse>(this.apiUrl, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
